<div class="container-fluid">
    <div class="row">
        <div class="col-8">
            <app-pagetitle title="States"></app-pagetitle>

        </div>
        <div class="col-4">
            <button class="btn btn-primary btn-sm float-end" (click)="openCreateModal(planModal)">
                <i class="mdi mdi-plus"></i> Add State
            </button>
        </div>
    </div>

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" searchBY="Name"
                                [isDateRange]="false"></app-filter>

                            <p-table #dt [value]="states" [lazy]="true" (onLazyLoad)="getStates($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" 
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Name</th>
                                        <th>Key</th>
                                        <th>Created At</th>
                                        <th>Updated At</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-state>
                                    <tr>
                                        <td>{{ state.name }}</td>
                                        <td>{{ state.key }}</td>
                                        <td>{{ state.createdAt | date:'short' }}</td>
                                        <td>{{ state.updatedAt | date:'short' }}</td>

                                        <td class="d-flex align-items-center gap-2">
                                            <!-- Edit -->
                                            <a href="javascript:void(0);" class="text-primary"
                                                (click)="openEditModal(state, planModal)" ngbTooltip="Edit State">

                                                <i class="mdi mdi-pencil font-size-18"></i>
                                            </a>

                                            <!-- Delete -->
                                            <!-- <a href="javascript:void(0);" class="text-danger" (click)="deleteState(state)"
                                        ngbTooltip="Delete State">

                                        <i class="mdi mdi-delete font-size-18"></i>
                                    </a> -->

                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No State found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #planModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{ isEditMode ? 'Edit State' : 'Create New State' }}</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="stateForm">
                    <div class="mb-3">
                        <label class="form-label">State Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="name" />
                        <div *ngIf="stateForm.get('name')?.hasError('required') && stateForm.get('name')?.touched"
                            class="text-danger small">State name is required.</div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Short State Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="key" />
                        <div *ngIf="stateForm.get('key')?.hasError('required') && stateForm.get('key')?.touched"
                            class="text-danger small">Short state name is required.</div>
                    </div>


                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submit()">{{ isEditMode ? 'Update' : 'Submit'
                    }}</button>
            </div>
        </ng-template>
    </div>
</div>